import Paragraph from "./Description.styled";

const Description = ({ content, ...props }) => {
  if (!content) return null;

  return <Paragraph {...props}>{content}</Paragraph>;
};

export default Description;
